{{model.propertyName}} - {{model.propertyType}}
@if (model.requiredValidation) {
  <br />
  <span class="red padding-left">Required</span>
}
@if (model.apiValidation) {
  <br />
  <span class="red padding-left">API # Format</span>
}
@if (appendComma) {
  <span>,</span>
}
